module.exports = __webpack_public_path__ + "img/logo-tienda-online.0c135c02.png";